import {
  PostAPI,
  PostAPIWithoutRequest,
  PostAPIWithoutRequestAndKeyData,
} from "src/components/api/helper/apiHelper";

export const SearchProduct = async (request: any) => {
  return PostAPI(request, 'SearchProduct/SearchProduct');
};